<template>
  <v-container
    fluid
    grid-list-md
  >
    <v-layout row wrap>
      <v-flex xs12>
        <v-toolbar flat>
          <h2>Планировщик</h2>
          <v-btn small text class="mx-1" color="secondary" :disabled="!ishyperadmin" @click="dialogNewSubject=true;fetch()">
            <v-icon>add</v-icon>
            Субъект
          </v-btn>
          <v-btn small text class="mx-1" color="secondary" :disabled="!ishyperadmin" @click="dialogNewJob=true;fetch()">
            <v-icon>add</v-icon>
            Задача
          </v-btn>
          <v-select
            :items="[
              { text: 'Все', value: null },
              { text: 'Открытые', value: false },
              { text: 'Завершенные', value: true }
            ]"
            v-model="finished"
            hide-details
            dense
            label="Завершенные"
            class="mx-3"
            style="max-width:200px"
          ></v-select>

          <v-dialog
            v-model="dialogNewJob"
            scrollable
            persistent modal
            width="640px"
            transition="dialog-transition"
          >
            <v-card>
              <v-card-title class="subtitle-1">
                Новая задача
                <v-spacer></v-spacer>
                <v-btn icon small @click="dialogNewJobClose()">
                  <v-icon>close</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <v-select
                  :items="subjects"
                  item-text="subjectid"
                  v-model="newJob.subjectid"
                  label="Субъект"
                  hide-details
                  dense
                ></v-select>
                <v-menu offset-y bottom>
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      label="старт"
                      v-model="newJob.start"
                      v-on="on"
                      :disabled="!newJob.subjectid"
                      hide-details
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    locale="ru" first-day-of-week="1"
                    v-model="newJob.start" :landscape="true" :reactive="true"
                  ></v-date-picker>
                </v-menu>
                <v-menu offset-y bottom>
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      label="финиш"
                      v-model="newJob.end"
                      v-on="on"
                      :disabled="!newJob.start"
                      hide-details
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    locale="ru" first-day-of-week="1"
                    v-model="newJob.end" :landscape="true" :reactive="true"
                  ></v-date-picker>
                </v-menu>

                <v-menu
                  ref="menu"
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="newJob.time"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="newJob.time"
                      label="Время выполнения"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :disabled="!newJob.end"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    v-if="menu2"
                    v-model="newJob.time"
                    full-width
                    use-seconds
                    @click:second="$refs.menu.save(newJob.time)"
                  ></v-time-picker>
                </v-menu>
              </v-card-text>
              <br /><br />

              <v-card-actions>
                <v-btn
                  :disabled="!newJob.time"
                  color="primary"
                  @click="addJob()"
                >
                  Добавить
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn text
                  @click="dialogNewJobClose()"
                >Отмена</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog
            v-model="dialogNewSubject"
            scrollable persistent modal
            width="640"
            transition="dialog-transition"
          >
            <v-card>
              <v-card-title class="subtitle-1">
                Новый субъект
                <v-spacer></v-spacer>
                <v-btn icon small @click="dialogNewSubjectClose()">
                  <v-icon>close</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <v-text-field
                  v-model="newSubject.subjectid"
                  label="subjectid"
                  dense
                ></v-text-field>
                <v-text-field
                  v-model="newSubject.topic"
                  :disabled="!newSubject.subjectid"
                  label="Топик"
                  dense
                ></v-text-field>
                <v-text-field
                  v-model="newSubject.params"
                  :disabled="!newSubject.topic"
                  label="Параметры (JSON)"
                  dense
                ></v-text-field>
                <v-select
                  :items="[{ text: 'Истина', value: true }, { text: 'Ложь', value: false }]"
                  v-model="newSubject.available"
                  :disabled="!newSubject.params"
                  label="Доступен?"
                  dense
                ></v-select>
              </v-card-text>
              <br /><br />

              <v-card-actions>
                <v-btn
                  :disabled="!newSubject.available"
                  color="primary"
                  @click="addSubject()"
                >
                  Добавить
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn text
                  @click="dialogNewSubjectClose()"
                >Отмена</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-spacer></v-spacer>

          <v-text-field
          label="поиск по фильтру"
          v-model="search"
          append-icon="search"
          style="max-width: 400px"
          outlined clearable hide-details flat
          ></v-text-field>

        </v-toolbar>
      </v-flex>
      <v-flex>
        <v-data-table
          :headers="headers"
          :items="jobs"
          :search="search"
          item-key="jobid"
          :footer-props="footerProps"
          no-data-text="пусто"
          no-results-text="ничего не найдено"
          :items-per-page.sync="itemsPerPage"
          dense
        >
        <template v-slot:item.subjectid="{ item }">
          <v-btn
            v-if="item.subjectid"
            text small color="primary" class="caption"
            @click="search = item.subjectid"
          >{{ item.subjectid }}</v-btn>
        </template>
        <template v-slot:item.subject.topic="{ item }">
          {{ item }}
        </template>
        <template v-slot:item.params="{ item }" max-width="200px">
          <v-tooltip left max-width="640" v-if="item.params !== null">
            <template v-slot:activator="{ on }">
              <v-list-item v-on="on" @click="() => { check=item; dialogCheck=true }" style="min-height: 26px !important">
                <v-list-item-subtitle class="caption pa-0" style="max-width: 60ch !important">
                  <span>{{ JSON.stringify(subjects.find(x => x.subjectid === item.subjectid).params).slice(0, 20) }}</span>
                </v-list-item-subtitle>
              </v-list-item>
            </template>
            <span>
              <span>{{ subjects.find(x => x.subjectid === item.subjectid).params }}</span>
            </span>
          </v-tooltip>
        </template>
        <template v-slot:item.results="{ item }" max-width="200px">
          <v-tooltip left max-width="640" v-if="item.results !== null">
            <template v-slot:activator="{ on }">
              <v-list-item v-on="on" @click="() => { check=item; dialogCheck=true }" style="min-height: 26px !important">
                <v-list-item-subtitle class="caption pa-0" style="max-width: 60ch !important">
                  <span>{{ JSON.stringify(item.results).slice(0, 20) }}</span>
                </v-list-item-subtitle>
              </v-list-item>
            </template>
            <span>
              <span>{{ item.results }}</span>
            </span>
          </v-tooltip>
        </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
const moment = require('moment')
export default {
  name: 'Scheduler',
  data: () => ({
    dialogNewJob: false,
    dialogNewSubject: false,
    jobs: [],
    subjects: [],
    search: '',
    finished: null,
    footerProps: {
      itemsPerPageText: 'показывать записей',
      itemsPerPageOptions: [ 25, 100, { text: 'Все', value: -1 } ]
    },
    itemsPerPage: 25,
    newSubject: {},
    newJob: {
      start: '',
      end: '',
      time: null
    },
    menu2: false,
  }),
  methods: {
    dateFormat (date) {
      if (date !== null) {
        return moment(date).format('YYYY-MM-DD HH:mm:ss')
      }
    },
    async fetch () {
      try {
        await Promise.all([
          await this.fetchSubjects(),
          await this.fetchJobs()
        ])
      } catch (err) {
        this.$store.dispatch('snack', err)
      }
    },
    async fetchJobs () {
      if (this.ishyperadmin) {
        const { jobs, meta } = await this.$store.dispatch('sioRequest', {
          topic: 'fetch-jobs',
          pl: {
            isfinished: this.finished,
            limit: 2000,
            orderby: 'plannedat',
            order: 'desc'
          }
        })
        this.jobs = jobs
          .filter(x => this.subjects.find(s => s.subjectid === x.subjectid))
          .map(j => {
            j.topic = this.subjects.find(x => x.subjectid === j.subjectid).topic
            j.plannedat = this.dateFormat(j.plannedat)
            j.startedat = this.dateFormat(j.startedat)
            j.finishedat = this.dateFormat(j.finishedat)
            j.cts = this.dateFormat(j.cts)
            return j
          })
      }
    },
    async fetchSubjects () {
      if (this.ishyperadmin) {
        const { subjects, meta } = await this.$store.dispatch('sioRequest', {
          topic: 'fetch-subjects',
          pl: {
            available: true
          }
        })
        this.subjects = subjects
      }
    },
    async searchJobs () {

    },
    async addSubject () {
      try {
        if (this.isJson(this.newSubject.params)) {
          this.newSubject.cby = this.$store.state.profile.email
          const { subject, meta } = await this.$store.dispatch('sioRequest', {
            topic: 'add-subject',
            pl: this.newSubject
          })
          this.$store.dispatch('snack', meta)
          this.dialogNewSubjectClose()
        }
      } catch (err) {
        this.$store.dispatch('snack', err)
      }
    },
    async addJob () {
      try {
        this.newJob.cby = this.$store.state.profile.email
        const { job, meta } = await this.$store.dispatch('sioRequest', {
          topic: 'add-job',
          pl: this.newJob
        })
        this.$store.dispatch('snack', meta)
        this.dialogNewJobClose()
      } catch (err) {
        this.$store.dispatch('snack', err)
      }
    },
    dialogNewJobClose () {
      this.dialogNewJob = false
      this.newJob = {}
    },
    dialogNewSubjectClose () {
      this.dialogNewSubject = false
      this.newSubject = {}
    },
    isJson (str) {
      try {
        const o = JSON.parse(str)
        if (o && typeof o === 'object') {
          return true
        } else {
          return false
        }
      } catch (err) {
        this.$store.dispatch('snack', err)
        return false
      }
    }
  },
  computed: {
    profile () {
      return this.$store.state.profile
    },
    scopes () {
      return this.profile ? this.profile.scopes : []
    },
    ishyperadmin () {
      return this.scopes.includes('hyperadmin')
    },
    headers () {
      return [
        { text: 'jobid', value: 'jobid', width: 80, align: 'right' },
        { text: 'subjectid', value: 'subjectid', width: 70, align: 'left' },
        { text: 'topic', value: 'topic', width: 180, align: 'left' },
        { text: 'plannedat', value: 'plannedat', width: 180, align: 'left' },
        { text: 'startedat', value: 'startedat', width: 180, align: 'left' },
        { text: 'finishedat', value: 'finishedat', width: 180, align: 'left' },
        { text: 'params', value: 'params', width: 100, align: 'left' },
        { text: 'results', value: 'results', width: 100, align: 'left' },
        { text: 'cby', value: 'cby', width: 80, align: 'left' },
        { text: 'cts', value: 'cts' },
      ]
    }
  },
  watch: {
    async profile (val) {
      if (val) await this.fetch()
    },
    async itemsPerPage () {
      await this.fetch()
    },
    async finished (val) {
      await this.fetch()
    }
  },
  mounted () {
    if (this.profile) this.fetch()
  }
}
</script>

<style lang="css">
</style>
